import Haskell from './haskell';

export default Haskell;
